import { render, staticRenderFns } from "./DestinationCarousel.vue?vue&type=template&id=bf9c70e6&scoped=true&"
import script from "./DestinationCarousel.vue?vue&type=script&lang=js&"
export * from "./DestinationCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c70e6",
  null
  
)

export default component.exports